<template>
  <div>
    <Popover
      v-model="popoverVisible"
      trigger="click"
      placement="bottomLeft"
      overlayClassName="hide-arrow"
      :align="{ offset: [0, 6] }"
      @visibleChange="handleVisibleChange"
    >
      <div :class="controlIconClasses">
        <div class="svg-icon-box">
          <SvgIcon icon-class="remind" />
        </div>
      </div>
      <div slot="content" style="width: 368px">
        <NotificationPane @show-more="handleShowMore" />
      </div>
    </Popover>
    <NotificationModal v-model="notificationModalVisible" v-if="notificationModalVisible" @change="doReading" :activeTab="activeTab" />
  </div>
</template>
<script>
import { Popover } from 'ant-design-vue'
import { mapActions, mapGetters } from 'vuex'
import SvgIcon from '../../behavior/svg-icon/index.vue'
import NotificationPane from '../notification-pane/index.vue'
import NotificationModal from '../notification-modal/index.vue'
import { NOTIFY_TYPE } from '@/utils/constant'
export default {
  name: 'HeaderToolNotification',
  components: {
    Popover,
    SvgIcon,
    NotificationPane,
    NotificationModal
  },
  data() {
    return {
      popoverVisible: false,
      notificationModalVisible: false,
      activeTab: NOTIFY_TYPE.IM_MSG_RELAY_NTY
    }
  },
  methods: {
    ...mapActions('notification', ['doReading']),
    handleShowMore(activeTab) {
      if (!activeTab) {
        activeTab = NOTIFY_TYPE.IM_MSG_RELAY_NTY
      }
      this.activeTab = activeTab
      this.popoverVisible = false
      this.doReading(true)
      this.notificationModalVisible = true
    },
    handleVisibleChange(visible) {
      if (!visible) {
        this.doReading(true)
        this.$nextTick(() => {
          this.doReading(false)
        })
      }
    }
  },
  computed: {
    ...mapGetters('notification', ['existsUnreadNotify']),
    controlIconClasses() {
      const popoverVisible = this.popoverVisible
      const showDot = !popoverVisible && this.existsUnreadNotify ? 'show-dot' : ''
      const controlOpen = popoverVisible ? 'control-active' : ''
      return `control-icon ${showDot} ${controlOpen}`
    }
  },
  beforeDestroy() {
    this.doReading(false)
  }
}
</script>
<style lang="less" scoped>
.control-icon {
  position: relative;
  font-size: 42px;
  color: #000;
  &.show-dot::after {
    position: absolute;
    top: 10px;
    left: 25px;
    content: " ";
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background: #fd6565;
  }

  &.control-active .svg-icon-box {
      background: #EFF3F8;
  }

  & > .svg-icon-box {
      border-radius: 8px;
      width: 42px;
      height: 42px;
      overflow: hidden;
      &:hover {
          cursor: pointer;
          background: #EFF3F8;
      }

      & > .svg-icon {
        vertical-align: top;
      }
  }
}
</style>
